import { useState } from 'react';
import { useAuth } from '../AuthContext';
import { canSwitchUsers } from '../permissions';
import '../styles/usermenu.css';

const ROLE_LABELS = {
  admin: 'Administrator',
  executive: 'Executive',
  manager: 'Manager',
  spx: 'Sr. Project Executive',
  pm: 'Project Manager',
  estimator: 'Estimator',
  bid_coordinator: 'Estimating Coordinator',
  viewer: 'Viewer',
};

export default function UserMenu() {
  const { user, viewAs, setViewAs, clearViewAs, allUsers, logout } = useAuth();
  const [showPicker, setShowPicker] = useState(false);

  if (!user) return null;

  return (
    <div className="user-menu">
      {user.impersonatedBy && (
        <div className="impersonation-banner">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
          Viewing as <strong>{user.displayName}</strong>
          <button className="btn-clear-impersonate" onClick={clearViewAs}>Exit</button>
        </div>
      )}

      <div className="user-info">
        <div className="user-avatar">
          {user.displayName.split(' ').map(n => n[0]).join('').toUpperCase()}
        </div>
        <div className="user-details">
          <div className="user-name">{user.displayName}</div>
          <div className="user-role">{user.title || ROLE_LABELS[user.role]}</div>
        </div>

        {canSwitchUsers(user) && !user.impersonatedBy && (
          <button
            className="btn-view-as"
            onClick={() => setShowPicker(!showPicker)}
            title="View as another user"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          </button>
        )}
      </div>

      <button className="btn-logout" onClick={logout} title="Sign out">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
        Sign Out
      </button>

      {showPicker && (
        <div className="viewas-dropdown">
          <div className="viewas-header">View As</div>
          {allUsers.filter(u => u.role === 'estimator' || u.role === 'bid_coordinator').map(u => (
            <div
              key={u.username}
              className={`viewas-option ${viewAs === u.username ? 'active' : ''}`}
              onClick={() => { setViewAs(u.username); setShowPicker(false); }}
            >
              <div className="viewas-avatar">
                {u.displayName.split(' ').map(n => n[0]).join('').toUpperCase()}
              </div>
              <div className="viewas-info">
                <div className="viewas-name">{u.displayName}</div>
                <div className="viewas-title">{u.title || ROLE_LABELS[u.role]}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
